import { formatSeconds } from "@/lib/voice";
import { MAX_RECORDING_SECONDS } from "@/lib/voice";

const TEXT = {
  idle: "Tap to talk",
  listening: "Listening — tap to send",
  transcribing: "Turning your words into text…",
  thinking: "Thinking… tap to stop",
  speaking: "Speaking — tap to interrupt",
};

export function VoiceStatus({ status, elapsed, available }) {
  return (
    <div className="mt-2 flex min-h-[56px] flex-col items-center gap-2 text-center">
      <p className="text-[15px] text-zinc-200" data-testid="voice-status">
        {available === false ? "Voice isn't available yet. Please check back soon." : TEXT[status]}
      </p>
      {status === "listening" ? (
        <span className="inline-flex items-center gap-2 rounded-full border border-rose-400/30 bg-rose-500/10 px-3 py-1 text-xs text-rose-200" data-testid="voice-mic-on">
          <span className="h-2 w-2 animate-pulse rounded-full bg-rose-400" />
          Microphone on · {formatSeconds(elapsed)} / {formatSeconds(MAX_RECORDING_SECONDS)}
        </span>
      ) : (
        <span className="inline-flex items-center gap-2 text-xs text-zinc-600" data-testid="voice-mic-off">
          <span className="h-1.5 w-1.5 rounded-full bg-zinc-600" />
          Microphone off
        </span>
      )}
    </div>
  );
}
